
import { defineComponent } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import AddDrawBundleForm from '@/components/drawBundles/AddDrawBundleForm.vue';

export default defineComponent({
  name: 'draw-bundle-add-modal',
  emits: ['update:modelValue', 'formSubmitted', 'close'],
  props: {
    modelValue: { type: Boolean, default: false },
  },
  components: {
    Modal,
    AddDrawBundleForm,
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    handleDataSubmitted() {
      this.$emit('formSubmitted');
    },

    handleClose() {
      this.$emit('close');
    },
  },
});
